import type { ProductView } from "./types";

/** Public rollout approved by the owner on 2026-09-10. Local UI, no auth needed. */
export const CATALOG_INTERACTIONS_ENABLED: boolean = true;

export interface CatalogPoint { x: number; y: number }

/** Uses the rendered image rect, so scroll and zoom need no special offsets. */
export function catalogProductsAtPoint(
  products: readonly ProductView[], point: CatalogPoint,
  rect: { left: number; top: number; width: number; height: number },
): ProductView[] {
  if (rect.width <= 0 || rect.height <= 0) return [];
  const x = (point.x - rect.left) / rect.width * 1000;
  const y = (point.y - rect.top) / rect.height * 1000;
  if (!Number.isFinite(x + y) || x < 0 || y < 0 || x >= 1000 || y >= 1000) return [];
  return products.filter(({ bounding_box: [top, left, bottom, right] }) =>
    x >= left && x < right && y >= top && y < bottom);
}

/** A click can open a card only after a short, stationary, single-pointer tap. */
export class CatalogTapTracker {
  private start: (CatalogPoint & { pointerId: number; at: number }) | null = null;
  private ready: (CatalogPoint & { at: number }) | null = null;
  begin(pointerId: number, point: CatalogPoint, at: number): void {
    this.cancel();
    this.start = { ...point, pointerId, at };
  }
  move(pointerId: number, point: CatalogPoint): void {
    if (this.start && (this.start.pointerId !== pointerId ||
      Math.hypot(point.x - this.start.x, point.y - this.start.y) > 10)) this.cancel();
  }
  end(pointerId: number, point: CatalogPoint, at: number): void {
    this.move(pointerId, point);
    if (this.start && at - this.start.at <= 550 && at >= this.start.at) this.ready = { ...point, at };
    this.start = null;
  }
  consume(at: number): CatalogPoint | null {
    const ready = this.ready;
    this.ready = null;
    return ready && at >= ready.at && at - ready.at <= 500 ? ready : null;
  }
  cancel(): void { this.start = null; this.ready = null; }
}
